import { defineComponent as _defineComponent } from 'vue'
import { createUserAccessToken } from '@/apis/userAccessToken'
import gBaseModal from '@/components/g-base-modal.vue'
import { translateLang } from '@/data/i18n/translateLang'
import { message } from 'ant-design-vue'
import type { Moment } from 'moment'
import moment from 'moment'
import { ref, watch } from 'vue'

import { fieldList } from '../data'

type ExpireType = '1d' | '30d' | 'custom'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-add-modal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["cancel", "success"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'cancel'): void
  (e: 'success', data: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
}





const EXPIRE_DAY_MAP: Record<Exclude<ExpireType, 'custom'>, number> = {
  '1d': 1,
  '30d': 30,
}

const formRef = ref<any>(null)
const isLoading = ref(false)
const expireType = ref<ExpireType | undefined>(undefined)
const form = ref({
  name: '',
  expire_time: '',
})

function getPresetExpireTime(type: Exclude<ExpireType, 'custom'>) {
  return moment().add(EXPIRE_DAY_MAP[type], 'day').format('YYYY-MM-DD HH:mm:ss')
}

watch(
  () => props.visible,
  (val) => {
    if (val) {
      expireType.value = void 0
      form.value = { name: '', expire_time: '' }
    }
  }
)

function handleExpireTypeChange(val: ExpireType, formState: typeof form.value) {
  if (val !== 'custom') {
    formState.expire_time = getPresetExpireTime(val)
  } else {
    formState.expire_time = ''
  }
}

function handleExpireTimeChange(formState: typeof form.value) {
  if (formState.expire_time) {
    formState.expire_time = moment(formState.expire_time).format(
      'YYYY-MM-DD HH:mm:ss'
    )
  }
  return formState
}

async function handleAdd() {
  isLoading.value = true
  try {
    const { status, msg, data } = await createUserAccessToken(
      handleExpireTimeChange({ ...form.value })
    )
    if (status !== 1) {
      return message.error(msg)
    }
    message.success(msg)
    emit('success', data)
  } finally {
    isLoading.value = false
  }
}

/** [start, end) 整数数组，用于 ant DatePicker disabledTime */
function range(start: number, end: number) {
  const result: number[] = []
  for (let i = start; i < end; i += 1) {
    result.push(i)
  }
  return result
}

function disabledExpireDate(current: Moment) {
  return Boolean(current && current.isBefore(moment().startOf('day')))
}

function disabledExpireTime(current: Moment | null) {
  if (!current || !current.isValid()) {
    return {}
  }
  const now = moment()
  if (!current.isSame(now, 'day')) {
    return {}
  }
  const hour = now.hour()
  const minute = now.minute()
  const second = now.second()
  return {
    disabledHours: () => range(0, hour),
    disabledMinutes: (selectedHour: number) => {
      if (selectedHour < hour) return range(0, 60)
      if (selectedHour > hour) return []
      return range(0, minute)
    },
    disabledSeconds: (selectedHour: number, selectedMinute: number) => {
      if (
        selectedHour < hour ||
        (selectedHour === hour && selectedMinute < minute)
      ) {
        return range(0, 60)
      }
      if (
        selectedHour > hour ||
        (selectedHour === hour && selectedMinute > minute)
      ) {
        return []
      }
      return range(0, second)
    },
  }
}

return { __sfc: true,props, emit, EXPIRE_DAY_MAP, formRef, isLoading, expireType, form, getPresetExpireTime, handleExpireTypeChange, handleExpireTimeChange, handleAdd, range, disabledExpireDate, disabledExpireTime, gBaseModal, translateLang, fieldList }
}

})